import { z } from 'zod';
import { LogoSchema } from './image-schema';
import { metaSchema } from './meta-schema';
import { tagSchema } from './tag-schema';
import { pageConfigurationSchema } from './page-configuration-schema';

export type TProduct = z.infer<typeof productSchema>;

export const productSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    background: z.object({
      data: z
        .array(
          z.object({
            id: z.number(),
            attributes: z.object({
              url: z.string(),
              alternativeText: z.string().optional().nullable(),
            }),
          }),
        )
        .nullable(),
    }),
    configuration: pageConfigurationSchema,
    description: z.string(),
    article: z.string().optional().nullable(),
    details: z.array(
      z.object({
        displayOnCard: z.boolean(),
        id: z.number(),
        key: z.string(),
        value: z.string(),
        icon: z.string().nullable(),
        moreInfo: z.string().nullable(),
      }),
    ),
    meta: metaSchema,
    logo: LogoSchema,
    tags: z.object({ data: z.array(tagSchema) }),
  }),
});
